import React, { useState, useEffect } from 'react';
import { Avatar, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { reqGetMe } from '../../services';
import './index.css';

interface UserInfo {
    email: string;
    organization_name: string;
}

const UserProfile: React.FC = () => {
    const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchUserInfo();
    }, []);

    const fetchUserInfo = async () => {
        try {
            setLoading(true);
            const data = await reqGetMe();
            console.log('User info received:', data);
            setUserInfo(data);
        } catch (error) {
            console.error('Error fetching user info:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="user-profile-loading">
                <Spin size="small" />
            </div>
        );
    }

    return (
        <div className="user-profile-container">
            <div className="user-profile-display">
                <Avatar 
                    size={32} 
                    icon={<UserOutlined />} 
                    className="user-avatar"
                />
                <div className="user-info">
                    <div className="user-email">{userInfo?.email || 'macbaokhanh2k2@gmail.com'}</div>
                    <div className="user-organization">{userInfo?.organization_name || 'GOFA'}</div>
                </div>
            </div>
        </div>
    );
};

export default UserProfile;
